export default "__VITE_ASSET__DjJrzRyY__"